import { useState, useEffect } from "react";
import UsersTable from "./UsersTable";
import UserCard from "./UserCard";

import Modal from "../../components/common/Modal";
import ConfirmDialog from "../../components/common/ConfirmDialog";
import StatusScreen from "../../components/common/StatusScreen";

import AddTechnicianForm from "../../components/users/AddTechnicianForm";
import axios from "axios";

export default function TechniciansPage() {
  const [technicians, setTechnicians] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showStatus, setShowStatus] = useState(false);

  const [pendingData, setPendingData] = useState(null);
  const [statusType, setStatusType] = useState("loading");
  const [statusMessage, setStatusMessage] = useState("");

  /* =========================================================================
     FETCH TECHNICIANS FROM BACKEND
     ======================================================================== */
  const loadTechnicians = async () => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_BACKEND_BASE_URL + "/api/v1/fetch/users/all",
        { params: { userType: "TECHNICIAN" } }
      );

      if (res.data?.data) {
        const mapped = res.data.data.map((t) => ({
          name: `${t.firstName} ${t.lastName}`,
          email: t.email,
          phone: t.phoneNumber,
          location: t.location,
          identityId: t.identityId,
          role: "Technician",
          status: t.status === "ACTIVE" ? "Active" : "Inactive",
          tractors: t.tractors || [],
        }));

        setTechnicians(mapped);
      }
    } catch (err) {
      console.error("Failed to refresh technicians →", err);
    }
  };

  /* =========================================================================
     AUTO-REFRESH EVERY 5 SECONDS
     ======================================================================== */
  useEffect(() => {
    loadTechnicians();

    const interval = setInterval(() => {
      loadTechnicians();
    }, process.env.REACT_APP_REFRESH_AFTER);

    return () => clearInterval(interval);
  }, []);

  /* =========================================================================
     HANDLE LOCAL FORM SUBMISSION
     ======================================================================== */
  const handleFormSubmit = (data) => {
    setPendingData(data);
    setShowModal(false);
    setShowConfirm(true);
  };

  /* =========================================================================
     CONFIRM SAVE
     ======================================================================== */
  const confirmSave = async () => {
    setShowConfirm(false);

    setStatusType("loading");
    setStatusMessage("Saving technician...");
    setShowStatus(true);

    await new Promise((res) => setTimeout(res, 1800));

    setStatusType("success");
    setStatusMessage("Technician added successfully!");

    setTimeout(() => setShowStatus(false), 1500);
  };

  /* ========================================================================= */

  return (
    <div className="dashboard-content min-h-full text-gray-900 dark:text-gray-100">
      <div className="dashboard-grid dashboard-grid-1 mb-6">
        <UserCard
          title="Total Technicians"
          count={technicians.length}
          color="#B1CB40"
          icon="🔧"
        />
      </div>

      <UsersTable
        data={technicians}
        title="Technician"
        onAddUser={() => setShowModal(true)}
        onViewUser={(user) => alert(JSON.stringify(user, null, 2))}
      />

      <Modal
        open={showModal}
        title="Add Technician"
        icon="🔧"
        onClose={() => setShowModal(false)}
      >
        <AddTechnicianForm onSubmit={handleFormSubmit} onClose={() => setShowModal(false)} />
      </Modal>

      <ConfirmDialog
        open={showConfirm}
        message="Are you sure you want to save this technician?"
        onConfirm={confirmSave}
        onCancel={() => setShowConfirm(false)}
      />

      <StatusScreen
        open={showStatus}
        status={statusType}
        message={statusMessage}
      />
    </div>
  );
}